import type { SpecWarning } from "../errors";

/**
 * 全 Phase で発生した `SpecWarning` を横断集約。`collect` 時に sheet 順 sort + dedup。
 */
export class WarningCollector {
  private readonly warnings: SpecWarning[] = [];

  add(warning: SpecWarning): void {
    this.warnings.push(warning);
  }

  /**
   * @returns ソート + 重複除去された警告配列 (新規配列、内部状態は不変)
   *
   * dedup キーは `(code, sheetName, rowIndex, columnName, context)`。context は
   * parser / builder が組み立てるフラットな string/number/boolean object のみ前提。
   */
  collect(): SpecWarning[] {
    const sorted = [...this.warnings].sort((a, b) => {
      const s = a.location.sheetName.localeCompare(b.location.sheetName);
      if (s !== 0) return s;
      const aRow = a.location.rowIndex ?? -1;
      const bRow = b.location.rowIndex ?? -1;
      if (aRow !== bRow) return aRow - bRow;
      return a.code.localeCompare(b.code);
    });
    const seen = new Set<string>();
    return sorted.filter((w) => {
      const key = JSON.stringify([
        w.code,
        w.location.sheetName,
        w.location.rowIndex ?? null,
        w.location.columnName ?? null,
        w.context ? sortedContextString(w.context) : null,
      ]);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }
}

/** context をキーソートして JSON 文字列化 (フラット object 前提)。 */
function sortedContextString(ctx: Record<string, unknown>): string {
  return JSON.stringify(ctx, Object.keys(ctx).sort());
}
